export default __webpack_public_path__ + "static/media/nip_8.b184fd04.jpg";